import api from './axios';
import { photoAllegee } from '../utils/photoLigne';

export const getDiscussions = () => api.get('/discussions');
export const getCanaux = () => api.get('/discussions/canaux');
// Recherche dans les messages de toutes mes conversations.
export const rechercherMessages = (q) => api.get('/discussions/recherche', { params: { q } });
export const creerDiscussion = (payload) => api.post('/discussions', payload);
export const renommerDiscussion = (id, nom) => api.patch(`/discussions/${id}`, { nom });
export const rejoindreCanal =(id) => api.post(`/discussions/${id}/rejoindre`);
export const ajouterMembre = (id, userId) => api.post(`/discussions/${id}/membres`, { user_id: userId });
export const getMembres = (id) => api.get(`/discussions/${id}/membres`);
export const retirerMembre = (id, userId) => api.delete(`/discussions/${id}/membres/${userId}`);
export const quitterDiscussion = (id) => api.delete(`/discussions/${id}/membres/moi`);
export const getMessages = (id, before) =>
  api.get(`/discussions/${id}/messages`, { params: before ? { before } : {} });
export const supprimerMessage = (id, mid) => api.delete(`/discussions/${id}/messages/${mid}`);
// files : photos ajoutees au message (celles deja la sont gardees).
export const modifierMessage = async (id, mid, body, files = []) => {
  if (!files.length) return api.patch(`/discussions/${id}/messages/${mid}`, { body });
  const fd = new FormData();
  fd.append('body', body || '');
  for (const f of files) fd.append('file', await photoAllegee(f));
  return api.patch(`/discussions/${id}/messages/${mid}`, fd);
};
export const transfererMessage = (id, mid, vers) =>
  api.post(`/discussions/${id}/messages/${mid}/transferer`, { vers });
export const basculerPouce = (id, mid) => api.post(`/discussions/${id}/messages/${mid}/pouce`);
export const marquerLu = (id) => api.patch(`/discussions/${id}/lu`);
export const signalerEcriture = (id) => api.post(`/discussions/${id}/ecrit`);

// Plusieurs fichiers possibles dans un meme message. Les images sont
// compressees avant envoi : cinq photos de telephone brutes depasseraient la
// limite serveur de 25 Mo par envoi.
// replyTo : id du message auquel on repond (cite au-dessus de la reponse).
export const envoyerMessage = async (id, { body, files = [], replyTo = null }) => {
  const fd = new FormData();
  fd.append('body', body || '');
  if (replyTo) fd.append('reply_to', String(replyTo));
  for (const f of files) {
    fd.append('file', await photoAllegee(f));
  }
  return api.post(`/discussions/${id}/messages`, fd);
};

// Pont chat → dossier SAV (secretaires) : cree une entree de diagnostic ou
// de reparation depuis un message, photos comprises.
export const versSav = (id, mid, { type, savId, technicienIds, texte }) =>
  api.post(`/discussions/${id}/messages/${mid}/vers-sav`,
    { type, sav_id: savId, technicien_ids: technicienIds, texte });

// EventSource ne porte pas de headers : token en query param.
export const streamURL = () =>
  `/api/discussions/stream?token=${encodeURIComponent(localStorage.getItem('token') || '')}`;
